import JSEncrypt from 'jsencrypt'

let pubKey = '-----BEGIN PUBLIC KEY-----MIGfMA0GCSqGSIb3DQEBAQUAA4GNADCBiQKBgQCDTwOlLIY3VQ//pJb0oU2otHuVAv7/g9UZbQ7WqAQ8754laUfoEBgYAt2RvJ0ume6WCTAGUw6eqbv/tVTeBi2T6ZrFSd5Aa2DOsKs5RJM46/P5vBZ0hKj3kioqURW3gDGXNMRJDW3S62sB3TS7ZCVXCmTy6ZxKYCr5wkdl3rhP1wIDAQAB-----END PUBLIC KEY-----'
let RSA = {
    //使用公钥加密

    encrypt(obj) {
        let encrypt = new JSEncrypt();
        encrypt.setPublicKey(pubKey); // 放置自己的公钥
        // let data = JSON.stringify(obj);

        if (obj.length >= 177) {
            function fixedLengthFormatString(str, num) {
            if (str == null || str == undefined) return null;
            if (!/^[0-9]*[1-9][0-9]*$/.test(num)) return null;
            var array = new Array();
            var len = str.length;
            for (var i = 0; i < len / num; i++) {
                if ((i + 1) * num > len) {
                array.push(str.substring(i * num, len));
                } else {
                array.push(str.substring(i * num, (i + 1) * num));
                }
            }
            return array;
            }
            let array = fixedLengthFormatString(obj, 176);
            let str = "";
            for (let i = 0; i < array.length; i++) {
            str += encrypt.encrypt(array[i]) + ",";
            }
            return str;
        } else {
            return encrypt.encrypt(obj);
        }
    }
}
export default RSA;